import { get } from './client.js';
import type { CalendarEmail, CalendarCustomer, DashboardOverview } from '../types/index.js';

export const dashboardApi = {
  overview: () => get<DashboardOverview>('/dashboard/overview'),
  /** 按时间范围（Unix 秒，含首尾）查询标记「日历」标签的邮件及范围内创建的客户 */
  calendar: (start: number, end: number) =>
    get<{ items: CalendarEmail[]; customers: CalendarCustomer[] }>(`/dashboard/calendar?start=${start}&end=${end}`),
};
